export const filterId = 'isPayerDataVisible' as const
